module.exports = __webpack_public_path__ + "resources/img/img_application_service_mesimesb_en.d9db4cabb4e8b5c18767551ed16fce75.png";